import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { PreviousReportFiles, PreviousReportFilesCollection } from './previousReports.types';

const usePreviousReportFiles = () => {
  const getPreviousReportquery = useCallback((collection: PreviousReportFilesCollection) => {
    return collection?.find({
      selector: { fkAsset: Number(getValueFromLocalStorage('assetId')) },
    });
  }, []);

  const { result } = useRxData<PreviousReportFiles>(
    RxdbCollectionName.PREVIOUS_REPORTS_FILES,
    getPreviousReportquery,
  );

  return { result };
};

export default usePreviousReportFiles;
